module.exports = __webpack_public_path__ + "013724bf433caeb8ecc412eaa2e03461.jpg";


//////////////////
// WEBPACK FOOTER
// ./author.jpg
// module id = 493
// module chunks = 0